import { useState } from 'react';
import './Sections.css';

const policies = {
  refund: {
    title: 'Refund Policy',
    body: `Polisi Pemulangan Wang — Buku TLP

Kami menawarkan jaminan wang dikembalikan 100% dalam tempoh 14 hari dari tarikh penerimaan buku.

Syarat pemulangan:
• Buku mestilah dalam keadaan asal dan tidak rosak.
• Pelanggan perlu menghubungi kami melalui emel di bukufizikaltlp@gmail.com dengan bukti pembelian.
• Pemulangan wang akan diproses dalam tempoh 7-14 hari bekerja selepas buku diterima semula oleh pihak kami.

Penghantaran semula buku adalah tanggungjawab pelanggan melainkan buku diterima dalam keadaan rosak.

Untuk sebarang pertanyaan, sila hubungi: bukufizikaltlp@gmail.com
BUKU TLP HQ`,
  },
  privacy: {
    title: 'Privacy Policy',
    body: `Polisi Privasi — Buku TLP

Maklumat yang kami kumpul:
• Nama, alamat emel, nombor telefon, dan alamat penghantaran yang diberikan semasa pembelian.

Cara kami menggunakan maklumat:
• Untuk memproses dan menghantar pesanan anda.
• Untuk berkomunikasi mengenai pesanan dan promosi (dengan kebenaran anda).

Cookies & Remarketing:
We use Facebook Ads Remarketing & TikTok Ads Remarketing to advertise this website across the Internet. Remarketing cookies track your visits to our website and enable us to show you relevant ads on other platforms.

You can opt out of remarketing by visiting:
• Facebook: facebook.com/settings/?tab=ads
• Google: google.com/settings/ads/anonymous
• General opt-out: networkadvertising.org/choices/

Kami tidak akan menjual atau berkongsi maklumat peribadi anda kepada pihak ketiga tanpa kebenaran anda.

Hubungi: bukufizikaltlp@gmail.com
BUKU TLP HQ`,
  },
  terms: {
    title: 'Terms & Conditions',
    body: `Terma & Syarat — Buku TLP

Dengan membuat pembelian di laman web ini, anda bersetuju dengan terma berikut:

1. Produk: Buku TLP adalah buku fizikal (hard copy) mengenai teknik trading emas.

2. Harga: Semua harga adalah dalam Ringgit Malaysia (MYR) dan termasuk penghantaran percuma ke seluruh Malaysia.

3. Penghantaran: 3-5 hari bekerja (Semenanjung), 5-7 hari bekerja (Sabah & Sarawak).

4. Hasil Trading: Hasil trading bergantung kepada usaha dan disiplin individu. Kami tidak menjamin sebarang pulangan kewangan.

5. Hak Cipta: Semua kandungan dalam buku adalah hak cipta Adam Danish / BUKU TLP HQ. Penyalinan atau pengedaran tanpa kebenaran adalah dilarang.

Disclaimer:
This site is not a part of the TikTok and Facebook website or Facebook Inc. Additionally, this site is not endorsed by Facebook and TikTok in any way. TikTok is a trademark of TikTok.com and Facebook is a trademark of Meta.

Hubungi: bukufizikaltlp@gmail.com
BUKU TLP HQ`,
  },
};

function PolicyModal({ id, onClose }) {
  const p = policies[id];
  if (!p) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>&times;</button>
        <h3>{p.title}</h3>
        <div className="modal-body">{p.body}</div>
      </div>
    </div>
  );
}

export default function Footer() {
  const [open, setOpen] = useState(null);

  return (
    <>
      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-top">
            <div className="footer-brand">
              <div className="footer-logo"><img src="/book-cover.png" alt="Buku TLP" className="fl-icon" /><span className="fl-text">Buku TLP</span></div>
              <p>Trade Like a Pro Player. Buku trading emas #1 di Malaysia oleh Adam Danish.</p>
            </div>
            <div className="footer-cols">
              <div className="fcol">
                <h4>Pautan</h4>
                <a href="#about" onClick={(e) => { e.preventDefault(); document.querySelector('.prob')?.scrollIntoView({ behavior: 'smooth' }); }}>Tentang</a>
                <a href="#offer" onClick={(e) => { e.preventDefault(); document.querySelector('#offer')?.scrollIntoView({ behavior: 'smooth' }); }}>Harga</a>
                <a href="#order-form" onClick={(e) => { e.preventDefault(); document.querySelector('#order-form')?.scrollIntoView({ behavior: 'smooth' }); }}>Pesanan</a>
              </div>
              <div className="fcol">
                <h4>Polisi</h4>
                <button onClick={() => setOpen('refund')}>Refund Policy</button>
                <button onClick={() => setOpen('privacy')}>Privacy Policy</button>
                <button onClick={() => setOpen('terms')}>Terms &amp; Conditions</button>
              </div>
              <div className="fcol">
                <h4>Hubungi</h4>
                <a href="mailto:bukufizikaltlp@gmail.com">bukufizikaltlp@gmail.com</a>
                <span className="fcol-note">BUKU TLP HQ</span>
              </div>
            </div>
          </div>
          <div className="footer-divider" />
          <div className="footer-bottom">
            <p>Copyright &copy; 2024 buku TLP .com All rights reserved.</p>
            <p className="footer-disclaimer">
              This site is not a part of the TikTok and Facebook website or Facebook Inc.
              Additionally, this site is not endorsed by Facebook and TikTok in any way.
              TikTok is a trademark of TikTok.com and Facebook is a trademark of Meta.
            </p>
          </div>
        </div>
      </footer>

      {open && <PolicyModal id={open} onClose={() => setOpen(null)} />}
    </>
  );
}
